/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import * as React from "react";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styles from "../../../../customer/styles/customerStyles.module.css";
import adminIndex from "../../../components/adminIndex.module.css";
import { Checkbox, CircularProgress } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrdersToExport,
  orderSelector,
} from "../../../../../redux/slices/orderSlice";
import OrderShippingModal from "./OrderShippingModal";
import { Icon } from "@iconify/react";
import OrderExpandCell from "../../../../../components/orders/OrderExpandCell";
import { manipulatedLineItems } from "../utils/manipulateLineItemsForExport";
import { validateAddress } from "../../../../customer/pages/orders/utils/validateAddress";
import DeleteOrderModal from "./DeleteOrderModal";
import ColoredSVG from "../../../../../components/ColoredSVG";
import { ReactComponent as EmailIcon } from "../../../assets/at.svg";
import { ReactComponent as PartialIcon } from "../../../assets/partially.svg";
import { ReactComponent as MissingQuotation } from "../../../assets/missing-quotation.svg";
import { ReactComponent as MissingHouse } from "../../../assets/house.svg";
import { ReactComponent as FullRefund } from "../../../assets/fullrefund.svg";
import { ReactComponent as PartialCancellation } from "../../../assets/partiallycanceled.svg";
import { ReactComponent as FullyCanceled } from "../../../assets/fullycancelled.svg";
import { capitalCase } from "../../../../../utils/capitalCase";

function Row(props) {
  const { row, tabValue } = props;
  const [open, setOpen] = React.useState(false);
  const shouldBold = open && { fontWeight: "500" };
  const { shippedOrdersToExport } = useSelector(orderSelector);
  const dispatch = useDispatch();

  // Fulfillment badge: same states and texts as before, Polaris tones.
  function getOrderChipProps(value) {
    const badge = (tone, text) => (
      <span
        role="button"
        tabIndex={0}
        onClick={() => setOpen(!open)}
        onKeyDown={(e) => e.key === "Enter" && setOpen(!open)}
        className={`${adminIndex.badge} ${adminIndex[tone]}`}
      >
        {text}
      </span>
    );
    if (value?.batch_flag === "Processing") return badge("neutral", "Processing batch");
    if (value?.status === "Refunded") return badge("critical", "Refunded");
    if (value?.financial_status === "refunded" || value?.status === "Canceled") {
      return badge("critical", "Canceled");
    }
    if (value?.status === "Waiting") return badge("violet", "Waiting");
    if (value?.status === "Failed" || value?.status === "failed") return badge("critical", "Failed");
    if (value?.status === "Shipped") return badge("success", "Shipped");
    if (value?.status === "Processing") return badge("info", "In process");
    if (value?.status === "Cancelled") return badge("neutral", "Cancelled");
  }

  const [isChecked, setIsChecked] = useState(false);

  const getShippedOrdersToExport = (item) => {
    const find = shippedOrdersToExport?.find(
      (order) => order.shopifyOrderDetailId === item.shopify_order_id
    );

    if (!find) {
      if (item.status === "Processing" && item?.batch_flag !== "Processing") {
        const total_products = manipulatedLineItems(item);

        dispatch(
          getOrdersToExport([...shippedOrdersToExport, ...total_products])
        );
      }
    } else {
      const filteredOrders = shippedOrdersToExport.filter(
        (order) => order.shopifyOrderDetailId !== item.shopify_order_id
      );
      dispatch(getOrdersToExport(filteredOrders));
    }
  };

  const customerInfo = !row?.customer_info?.email;
  const streetHouseNumber = !row?.shipping_details?.address1;
  const addressWithHouseNumber = validateAddress(
    `${row?.shipping_details?.address1} ${row?.shipping_details?.address2}`
  );

  const mapRequired = row?.line_items?.filter(
    (item) => item.status === "not found"
  );

  const productCost = row?.pricing?.product_cost;

  const finalShippingCost = (order) => {
    let shippingCost = 0;
    if (
      order?.shipping_method === "premium" &&
      order?.pricing?.total_shipping_cost_non_electric_premium > 0
    ) {
      shippingCost = `${(
        row?.pricing?.total_shipping_cost +
        row?.pricing?.total_shipping_cost_non_electric_premium
      ).toFixed(2)}`;
    } else {
      shippingCost = row?.pricing?.total_shipping_cost?.toFixed(2);
    }
    return shippingCost;
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          borderBottom: "1px solid #ebebeb",
          "&:hover": {
            backgroundColor: "rgba(244,244,244,.5)",
          },
        }}
      >
        <TableCell
          style={{ paddingLeft: 0, paddingRight: 0 }}
          onClick={() => {
            getShippedOrdersToExport(row);
            setIsChecked(!isChecked);
          }}
        >
          <IconButton aria-label="expand row" size="small">
            <Checkbox
              checked={
                shippedOrdersToExport?.find(
                  (order) => order.shopifyOrderDetailId === row.shopify_order_id
                ) || open
                // selectAll
              }
            />
          </IconButton>
        </TableCell>
        <TableCell
          sx={shouldBold}
          onClick={() => setOpen(!open)}
          align="left"
          style={{
            paddingLeft: 0,
            paddingRight: 0,
            display: "flex",
            // justifyContent: "start",
            marginTop: "15px",
            alignItems: "center",
            // border:"1px solid gray"
          }}
        >
          <div
            style={{
              display: "flex",
              // justifyContent: "center",
              alignItems: "center",
              width: "180px",
              // width:"auto",
              position: "relative",
            }}
          >
            <div style={{ fontWeight: 700 }}>{row?.shopify_order_number}</div>
            {((mapRequired?.length > 0 ||
              customerInfo ||
              streetHouseNumber ||
              typeof addressWithHouseNumber === "string" ||
              row?.refunded_line_items?.length > 0) && (row?.status === "Failed" || row?.status === "Waiting")) && (
              // <InfoIcon fontSize="extra_samll" />
              <div style={{ position: "absolute", left: 42 }}>
                <div style={{ width: "auto", marginLeft: "10px" }}>
                  <ColoredSVG
                    backgroundColor={
                      row?.refunded_line_items?.length > 0 && !row?.refund_type
                        ? "#9ae2ff"
                        : "#FFAFA7"
                    }
                    file={
                      mapRequired.length > 0
                        ? MissingQuotation
                        : row?.refunded_line_items?.length > 0 &&
                          !row?.refund_type
                        ? PartialIcon
                        : row?.refund_type === "REFUND DISPUTE"
                        ? FullRefund
                        : row?.refund_type === "PARTIAL CANCELLATION"
                        ? PartialCancellation
                        : row?.refund_type === "PARTIAL REFUND DISPUTE"
                        ? PartialCancellation
                        : row?.refund_type === "CANCELLATION"
                        ? FullyCanceled
                        : customerInfo
                        ? EmailIcon
                        : streetHouseNumber
                        ? MissingHouse
                        : addressWithHouseNumber === "missing house#" ||
                          addressWithHouseNumber === "missing street"
                        ? MissingHouse
                        : EmailIcon
                    }
                    color={
                      row?.refunded_line_items?.length > 0 && !row?.refund_type
                        ? "#0093ff"
                        : "#ff0822"
                    }
                    text={
                      mapRequired.length > 0
                        ? "Missing Quotation"
                        : row?.refunded_line_items?.length > 0 &&
                          !row?.refund_type
                        ? "Partially Refunded"
                        : row?.refund_type
                        ? capitalCase(row?.refund_type)
                        : customerInfo
                        ? "Missing E-mail"
                        : streetHouseNumber
                        ? "Address Error"
                        : addressWithHouseNumber === "missing house#"
                        ? "Missing House#"
                        : addressWithHouseNumber === "missing street" &&
                          "Missing Street"
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </TableCell>

        <TableCell
          sx={shouldBold}
          style={{ paddingLeft: 0, paddingRight: 0 }}
          onClick={() => setOpen(!open)}
          align="center"
        >
          {row?.store?.store_name}
          <h6 style={{ marginBottom: 10 }}>
            {row?.user?.first_name + " " + row?.user?.last_name}
          </h6>
        </TableCell>

        <TableCell
          sx={shouldBold}
          style={{ paddingLeft: 0, paddingRight: 0 }}
          onClick={() => setOpen(!open)}
          align="center"
        >
          {dayjs(row?.created_at_shopify).format("YYYY-MM-DD")}
        </TableCell>
        <TableCell
          sx={shouldBold}
          onClick={() => setOpen(!open)}
          align="center"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          {row?.customer_info
            ? row?.customer_info?.first_name +
              " " +
              row?.customer_info?.last_name
            : "Not available"}
        </TableCell>
        <TableCell
          sx={shouldBold}
          onClick={() => setOpen(!open)}
          align="center"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          € {productCost ? productCost.toFixed(2) : 0}
        </TableCell>
        <TableCell
          sx={shouldBold}
          onClick={() => setOpen(!open)}
          align="center"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          {row?.pricing?.total_shipping_cost
            ? `€${finalShippingCost(row)}`
            : `€0`}
        </TableCell>
        <TableCell sx={shouldBold} align="right" style={{ width: "15%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {getOrderChipProps(row)}
          </div>
        </TableCell>
        <TableCell sx={shouldBold} align="right">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {row?.status === "Processing" || row?.status === "Shipped" ? (
              <div style={{ display: "flex" }}>
                {row?.status === "Processing" && (
                  <OrderShippingModal orderId={row?._id} />
                )}
                <DeleteOrderModal order={row} tabValue={tabValue} />
              </div>
            ) : (
              <Icon
                icon="material-symbols:edit-square-outline"
                width="20"
                height="20"
                style={{ marginRight: "5px", color: "#dddadaa7" }}
              />
            )}
          </div>
        </TableCell>
      </TableRow>
      <>
        <TableRow>
          <TableCell
            style={{
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }}
            colSpan={12}
          >
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
              style={{ padding: 0, margin: 0 }}
            >
              {/* <OrderExpandContent row={row} /> */}
              <OrderExpandCell
                row={row}
                finalShippingCost={finalShippingCost}
              />
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    </React.Fragment>
  );
}

export default function OrderTableCell({ data, tabValue }) {
  const dispatch = useDispatch();
  const [selectAll, setSelectAll] = useState(false);
  const [orderBy, setOrderBy] = useState("ASC");
  const [sortedData, setSortedData] = useState(data);
  const [colName, setColName] = useState("");
  const { isLoading, shippedOrdersToExport } = useSelector(orderSelector);

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  // sorting function for each table column
  const sorting = (col) => {
    setColName(col);
    if (orderBy === "ASC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setSortedData(sorted);
      setOrderBy("DSC");
    }
    if (orderBy === "DSC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setSortedData(sorted);
      setOrderBy("ASC");
    }
  };
  const tableHeadStyles = {
    color: "#707070",
    fontWeight: 500,
    cursor: "pointer",
  };

  const getAllInProcessOrders = (items) => {
    const ordersToAdd = [];
    let updatedOrders = [...shippedOrdersToExport];

    items.forEach((item) => {
      const find = updatedOrders.find(
        (order) => order.shopifyOrderDetailId === item.shopifyOrderDetailId
      );

      if (!find) {
        if (item.status === "Processing") {
          const total_products = manipulatedLineItems(item);
          ordersToAdd.push(...total_products);
        }
      } else {
        const filteredOrders = updatedOrders.filter(
          (order) => order.shopifyOrderDetailId !== item.shopifyOrderDetailId
        );
        updatedOrders = filteredOrders;
      }
    });

    if (ordersToAdd.length > 0) {
      updatedOrders = [...updatedOrders, ...ordersToAdd];
    }

    dispatch(getOrdersToExport(updatedOrders));
  };

  useEffect(() => {
    if (shippedOrdersToExport?.length > 50 && selectAll) {
      getAllInProcessOrders(sortedData);
    }
  }, [sortedData]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        boxShadow: "none",
        borderRadius: 0,
      }}
    >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow
            sx={{
              background: "#eeeeee",
            }}
          >
            <TableCell
              style={{ paddingLeft: 0, paddingRight: 0 }}
              onClick={() => {
                //  getShippedOrdersToExport(row);
                setSelectAll(!selectAll);
                getAllInProcessOrders(sortedData);
                if (selectAll) {
                  dispatch(getOrdersToExport([]));
                }
              }}
            >
              {sortedData[0]?.status === "Processing" && (
                <IconButton aria-label="expand row" size="small">
                  <Checkbox checked={selectAll} />
                </IconButton>
              )}
            </TableCell>

            <TableCell
              sx={tableHeadStyles}
              onClick={() => sorting("shopify_order_id")}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                // width: "10%",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: "10px",
              }}
            >
              <div className={styles.flex_center}>
                <strong>Order ID</strong>
                {colName === "shopify_order_id" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>

            <TableCell
              sx={tableHeadStyles}
              onClick={() => sorting("shopify_order_id")}
              align="center"
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                width: "10%",
              }}
            >
              <div className={styles.flex_center}>
                <strong>Store name</strong>
                {colName === "shopify_order_id" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="center"
              sx={tableHeadStyles}
              onClick={() => sorting("createdAt")}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                width: "15%",
              }}
            >
              <div className={styles.flex_center}>
                <strong>Date</strong>
                {colName === "createdAt" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="left"
              sx={tableHeadStyles}
              onClick={() => sorting(`customer_info`)}
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <div className={styles.flex_center}>
                <strong>Customer</strong>

                {colName === "customer_info" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="center"
              sx={tableHeadStyles}
              onClick={() => sorting("total_price")}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                width: "15%",
              }}
            >
              <div className={styles.flex_center}>
                <strong>Cost</strong>
                {colName === "total_price" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="center"
              sx={tableHeadStyles}
              onClick={() => sorting("shipping")}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                width: "10%",
              }}
            >
              <div className={styles.flex_center}>
                <strong>Shipping</strong>

                {colName === "shipping" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="right"
              sx={tableHeadStyles}
              onClick={() => sorting("status")}
              style={{ paddingLeft: 0 }}
            >
              <strong>Fulfillment</strong>
              {colName === "status" && orderBy === "ASC" ? (
                <ArrowDownward className={styles.arrow_font} />
              ) : (
                <ArrowUpward className={styles.arrow_font} />
              )}
            </TableCell>
            <TableCell
              align="right"
              sx={tableHeadStyles}
              onClick={() => sorting("status")}
              style={{ paddingLeft: 0 }}
            >
              <strong>Action</strong>
              {colName === "status" && orderBy === "ASC" ? (
                <ArrowDownward className={styles.arrow_font} />
              ) : (
                <ArrowUpward className={styles.arrow_font} />
              )}
            </TableCell>
          </TableRow>
        </TableHead>

        {!isLoading && (
          <TableBody>
            {sortedData?.map((row) => (
              <Row
                key={row._id}
                row={row}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                tabValue={tabValue}
              />
            ))}
          </TableBody>
        )}
      </Table>
      {isLoading && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress
            sx={{
              marginTop: "50px",
            }}
            disableShrink
          />
        </div>
      )}
    </TableContainer>
  );
}
